import React, { useState, useEffect } from 'react';

import './index.css';

const Component = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/home/contact.json`;

    const [content, setContent] = useState({
        labName: 'Blockchain & Robotics (PLANR) Lab',
        department: 'Department of Computer Science & Engineering',
        location: 'R-502, 5th Floor, Block 3',
        address: 'R-502, 5th Floor, Block 3, IIT Patna, Bihta, Bihar, India - 801106',
        phone: '+91 612 3028889',
        professorInCharge: {
            name: 'Dr. Raju Halder',
            website: 'https://www.iitp.ac.in/~halder'
        },
        email: 'halder@iitp.ac.in'
    });

    useEffect(() => {
        // GET Payload
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    const setEmail = (email) => {
        const [username, domain] = email.split('@');
        return (
            <>
                {username}
                <i className="fas fa-at" />
                {domain.split('.').map((item, index, domContent) => {
                    if (index !== domContent.length - 1)
                        return <span key={index}>{item}&bull;</span>;

                    return <span key={index}>{item}</span>;
                })}
            </>
        );
    };

    return (
        <div className="contact" id="Contact">
            <h3>Contact</h3>
            <p>
                <span className="contact-field">Lab Name:</span>&nbsp;{content.labName}
            </p>
            <p>
                <span className="contact-field">Professor In-Charge:</span>&nbsp;
                {content.professorInCharge.name}&nbsp;(
                <a href={content.professorInCharge.website} target="blank">
                    {content.professorInCharge.website}
                </a>
                )
            </p>
            <p>
                <span className="contact-field">Department:</span>&nbsp;{content.department}
            </p>
            <p>
                <span className="contact-field">Phone:</span>&nbsp;{content.phone}
            </p>
            <p>
                <span className="contact-field">E-Mail:</span>&nbsp;{setEmail(content.email)}
            </p>
            <p>
                <span className="contact-field">Address:</span>&nbsp;{content.address}
            </p>
        </div>
    );
};

export default Component;
